// extracted by mini-css-extract-plugin
module.exports = {"popup-content":"Popup_popup-content__6kT5g","popup-arrow":"Popup_popup-arrow__mSnfp","popup-overlay":"Popup_popup-overlay__QsbxP"};